// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner-module__spinnerContainer___18x24","spinnerCircle":"Spinner-module__spinnerCircle___1mVtK","rotation":"Spinner-module__rotation___3St5L"};